import { FunctionComponent } from 'react'

import { Icon, IIconProps } from 'native-base'
import { Path } from 'react-native-svg'

type Props = IIconProps & { size?: number }

export const AlertIcon79: FunctionComponent<Props> = ({ size, ...props }) => {
  const originalWidth = 20.0

  const originalHeight = 10.0

  const maxDim = Math.max(originalWidth, originalHeight)

  const scale = size ? size / maxDim : 1

  const width = originalWidth * scale

  const height = originalHeight * scale

  return (
    <Icon viewBox="0 0 20 10" width={width} height={height} {...props}>
      <Path
        d="M4.5 0C4.776 0 5 0.22386 5 0.5V1H7.70001L9.37402 0.14856C10.076 -0.09803 10.56 -0.0132597 11.526 0.37206L15 1.762V0.5C15 0.25454 15.177 0.05039 15.41 0.00804996L15.5 0H19.5C19.776 0 20 0.22386 20 0.5V7.01401C20 8.11111 19.111 9.00001 18.014 9.00001H15.5C15.224 9.00001 15 8.77611 15 8.50001V7.62301L14.913 7.54501L13.36 8.67471C11.357 10.1311 8.64301 10.1311 6.64001 8.67471L5 7.48201V8.50001C5 8.77611 4.776 9.00001 4.5 9.00001H1.98602C0.889023 9.00001 0 8.11111 0 7.01401V0.5C0 0.22386 0.224 0 0.5 0H4.5ZM6.34198 2.00043L5 2V6.24501L7.22803 7.86591C8.81703 9.02121 10.948 9.06561 12.579 7.99921L12.772 7.86591L14.152 6.86101L10.212 3.31821C10.188 3.32991 10.161 3.34231 10.134 3.35541L10.048 3.39671C9.67197 3.57761 9.23901 3.79831 8.755 4.06011C7.75901 4.59841 6.69702 4.55771 6.21002 3.73091C5.87002 3.15621 5.93198 2.54316 6.34198 2.00043ZM4 1H1V7.01401C1 7.55881 1.44102 8.00001 1.98602 8.00001H4V1ZM19 1H16V8.00001H18.014C18.559 8.00001 19 7.55881 19 7.01401V1ZM9.76801 1.06551L7.724 2.10925C7.04 2.5112 6.87698 2.89451 7.07098 3.22221C7.22098 3.47721 7.69699 3.49541 8.27899 3.18051C8.77699 2.91111 9.22401 2.68322 9.61401 2.49563C9.85001 2.38203 10.016 2.30655 10.105 2.26808C10.284 2.19089 10.492 2.22501 10.637 2.35546L14.98 6.25901L15 6.24401V2.838L11.155 1.30069C10.398 0.99884 10.113 0.94889 9.76801 1.06551Z"
        fill="#404040"
      />
    </Icon>
  )
}
